export function getText(entity) {
    // @ts-ignore
    if (entity.index !== undefined) {
        // @ts-ignore
        return entity.comment;
    }
    else {
        // @ts-ignore
        return entity.text;
    }
}
export function withText(entity, newText) {
    const copy = Object.assign({}, entity);
    // @ts-ignore
    if (entity.index !== undefined) {
        // @ts-ignore
        copy.comment = newText;
    }
    else {
        // @ts-ignore
        copy.text = newText;
    }
    return copy;
}
